import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    search: '/dashboard/v2/customer_success/customer/search/',
    user: '/dashboard/v2/customer_success/customer/{id}/user/',
    collaborators: '/dashboard/v2/customer_success/customer/{id}/collaborators/',
    reactivate: '/dashboard/v2/customer_success/customer/{id}/reactivate/',
    deactivate: '/dashboard/v2/customer_success/customer/{id}/deactivate/',
    change_password: '/dashboard/v2/customer_success/customer/{id}/change_password/',
    enable_dashboard: '/dashboard/v2/customer_success/customer/{id}/enable_dashboard/',
    disable_dashboard: '/dashboard/v2/customer_success/customer/{id}/disable_dashboard/',
    setVirtual: '/dashboard/v2/customer_success/customer/{id}/set_virtual/',
    unsetVirtual: '/dashboard/v2/customer_success/customer/{id}/unset_virtual/',
    changeAccountEmail: '/dashboard/api/v3/customers/{id}/change_email/',
}

export default {
    async searchUsers(filters) {
        if (!filters.user_id || filters.user_id.length === 0) delete filters.user_id
        if (!filters.email || filters.email.length === 0) delete filters.email
        if (!filters.pica_code || filters.pica_code.length === 0) delete filters.pica_code
        if (Object.keys(filters).length <= 0) return []

        return await client.post(endpoints.search, {
            ...filters,
        })
    },
    async fetchUser(id) {
        return await client.get(endpoints.user.replace('{id}', id))
    },
    async fetchCollaborators(id) {
        return await client.get(endpoints.collaborators.replace('{id}', id))
    },
    async reactivate(id) {
        return await client.post(endpoints.reactivate.replace('{id}', id))
    },
    async deactivate(id) {
        return await client.post(endpoints.deactivate.replace('{id}', id))
    },
    async changePassword(id, password) {
        return await client.post(endpoints.change_password.replace('{id}', id), {
            password: password
        })
    },
    async enableDashboard(id) {
        return await client.post(endpoints.enable_dashboard.replace('{id}', id))
    },
    async disableDashboard(id) {
        return await client.post(endpoints.disable_dashboard.replace('{id}', id))
    },
    async setVirtualUser(userId) {
        return await client.post(endpoints.setVirtual.replace('{id}', userId))
    },
    async unsetVirtualUser(userId) {
        return await client.post(endpoints.unsetVirtual.replace('{id}', userId))
    },
    async changeAccountEmail(userId, email) {
        return await client.post(endpoints.changeAccountEmail.replace('{id}', userId), { email })
    },
}
